export default "__VITE_ASSET__6n4uOTy$__"